import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import {
  Global
} from '../model';
import {
  PLANNER_CLICK_SEARCH_COLLAPSE,
} from 'apps/events';

import PlannerControllerBase from './base';
export default class SearchController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    this.customEvent(PLANNER_CLICK_SEARCH_COLLAPSE, (e) => { this.onClickSearchCollapse(e) });
  }
  onClickSearchCollapse(e){
    let boolean = App.store.getState().data.forms_planner_search.show
    this.updateData({
      forms_planner_search: {
        show: !boolean
      }
    });
  }
}
